import styles from "./AwardsCells.module.css";

type TypeCategoryCellProps = {
  awardTypeName: string;
  /** Null on every imported row today — the spreadsheet's "Category" column maps
   * 1:1 onto the award type, so nothing populates it until the CRUD phase. */
  categoryName: string | null;
};

/**
 * "Type of Award / Category" — the award type on top, the category underneath.
 *
 * With no category there is no second line *at all*: rendering an empty span
 * would leave the `gap` behind and push the type off the cell's vertical centre
 * on every row in the table, which is every row today.
 */
export function TypeCategoryCell({ awardTypeName, categoryName }: TypeCategoryCellProps) {
  return (
    <div className={styles.twoLineCell}>
      {/* The contract types this non-nullable, but a dictionary row the importer
          could not resolve comes back as an empty string rather than a name. */}
      <span className={styles.primaryLine}>{awardTypeName || "—"}</span>
      {categoryName ? <span className={styles.secondaryLine}>{categoryName}</span> : null}
    </div>
  );
}
